import { configureStore } from "@reduxjs/toolkit";

import clientDataReducer from "../store/slices/clientData";
import budgetDataReducer from "../store/slices/budgetData";
import appDialogReducer from "../store/slices/appDialog";

const store = configureStore({
    reducer: {
        clientData: clientDataReducer,
        budgetData: budgetDataReducer,
        appDialog: appDialogReducer
    },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;